import { Braces } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BracketsIcon = createLucideIcon(Braces);
